export const toQuotes = '/customer/account/history/quotes'

export function toQuoteDetailPage({ quoteId, posId }: { quoteId: string; posId: string }) {
  return `/customer/account/history/quotes/${quoteId}?pos=${posId}`
}

export function toCurrentQuote(quoteId: number) {
  return `/customer/account/history/quotes/${quoteId}/edit`
}

export const toQuoteConfirmationPage = '/quote-confirmation'

export function isQuoteConfirmationPage(pathname: string) {
  return pathname.startsWith(toQuoteConfirmationPage)
}
